import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/contact/importer/contactImporterActions';

export default importerReducers(actions);
